import { useState } from 'react';
import { DialogV2, AritoIcon, Button } from '@/components/custom/erp';
import { AssetGroup } from '@/types/schemas/nhom-tscd.type';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: AssetGroup | null;
  deleteAssetGroup: (id: string) => Promise<void>;
  clearSelection: () => void;
}

const DeleteDialog = ({ open, onClose, selectedObj, deleteAssetGroup, clearSelection }: DeleteDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!selectedObj) return;

    setIsDeleting(true);
    setError(null);

    try {
      await deleteAssetGroup(selectedObj.uuid);
      onClose();
      clearSelection();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra khi xóa nhóm TSCĐ');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xác nhận xóa'
      maxWidth='sm'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
    >
      <div className='p-4'>
        <p className='mb-4'>
          Bạn có chắc chắn muốn xóa nhóm TSCĐ <strong>{selectedObj?.ten_phan_nhom}</strong> không?
        </p>

        {error && <div className='mb-4 rounded bg-red-100 p-2 text-red-700'>{error}</div>}

        <div className='flex justify-end gap-2'>
          <Button onClick={handleDelete} disabled={isDeleting} className='bg-red-600 text-white hover:bg-red-700'>
            <AritoIcon icon={885} marginX='4px' />
            {isDeleting ? 'Đang xóa...' : 'Xóa'}
          </Button>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            <AritoIcon icon={889} marginX='4px' />
            Hủy
          </Button>
        </div>
      </div>
    </DialogV2>
  );
};

export default DeleteDialog;
